import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('TransportationInventoryService', TransportationInventoryService);

  TransportationInventoryService.$inject = [
    'RestResource',
    '$translate',
    '$filter',
    'UtilService',
    'TransportationInventoryModalService',
  ];

  function TransportationInventoryService(
    RestResource,
    $translate,
    $filter,
    UtilService,
    TransportationInventoryModalService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'transportation_inventories';

    var service = {
      getTransportationInventory: getTransportationInventory,
      saveTransportationInventory: saveTransportationInventory,
      saveTransportationInventoriesByDates: saveTransportationInventoriesByDates,
      openTransportationInventoryModal: openTransportationInventoryModal,
    };

    return service;

    ////////////////

    function getTransportationInventory(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = {};
      }

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveTransportationInventory(item) {
      function success(response) {
        utils._successMsg($translate('INVENTORY_UPDATED'));
        if (!item.id) {
          // New
          item.id = response.data.id;
        }

        item.total_availability = response.data.total_availability;

        utils.itemListChanged(item.id);

        return true;
      }
      function failure(response) {
        utils._errorMsg(response.data.error);
        return false;
      }

      var method = item.id ? 'put' : 'post';
      var url = item.id ? apiUrl + '/' + item.id : apiUrl;

      return RestResource.request(method, url, item, success, failure);
    }

    function saveTransportationInventoriesByDates(item) {
      function success() {
        utils._successMsg($translate('INVENTORY_UPDATED'));
        return true;
      }
      function failure(response) {
        utils._errorMsg(response.data.error);
        return false;
      }

      var url = apiUrl + '/change_total_by_dates';

      return RestResource.request('post', url, item, success, failure);
    }

    function openTransportationInventoryModal(item, successCallback) {
      TransportationInventoryModalService.openTransportationInventoryModal(item, successCallback);
    }
  }
})();
